interface ENV {
  classicDipoURL: string;
  webURL: string;
  apiURL: string;
  ssoURL: string;
  maxRequest: number;
}

const pEnv = process.env as Record<string, string>;

export const env: ENV = {
  classicDipoURL: pEnv.REACT_APP_CLASSIC_DIPO_URL,
  webURL: pEnv.REACT_APP_WEB_URL,
  apiURL: pEnv.REACT_APP_API_URL,
  ssoURL: pEnv.REACT_APP_SSO_URL,
  maxRequest: parseInt(pEnv.REACT_APP_MAX_REQUEST, 10) || 1,
};
